import React, { useState, useCallback, useEffect } from "react";
import {
  TextField,
  InputAdornment,
  Modal,
  Paper,
  Typography,
  CircularProgress,
  Grid,
  useTheme,
  Button,
  Link,
  IconButton,
  Tooltip,
  Box
} from "@material-ui/core";
import { useSelector } from 'react-redux';


import Alert from '@material-ui/lab/Alert';
import { Close, Search as SearchIcon, Add, Save } from "@material-ui/icons";
import { pathOr, clone } from "ramda";
import { MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import { Scrollbars } from 'react-custom-scrollbars';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  getRelateFieldData,
  relateFieldSearch,
  relatePopupCreateSubmit
} from "../../../store/actions/module.actions";
import { saveAs } from 'file-saver';
import { validateForm } from "../../../common/utils";
import useStyles, { getMuiTheme } from "./styles";
import { FormInput } from "../../";
import SearchView from "./search-view";
import { toast } from "react-toastify";

import FileViewerComp from "../../FileViewer/FileViewer";
import { useHistory } from "react-router-dom";

const Relate = ({ field, onChange, value, errors = {}, small = false, module = '', isIconBtn = false, btnIcon = null, isSelectBtn = false, tooltipTitle, variant = "outlined", multiSelect = false,component='',reportsTo=null,view=null,disabled=false,userData=[],color=""}) => {
  
  
  const {app_list_strings} = useSelector((state) => state.config.config);
  const { currentUserData } = useSelector((state) => state.config);
  const currentUserId = pathOr("",["data","attributes","id"],currentUserData);
  const currentUserName = pathOr("",["data","attributes","full_name"],currentUserData);
  const [modalVisible, toggleModalVisibility] = useState(false);
  const [createViewVisible, setCreateViewVisibility] = useState(false);
  const [filterViewVisible, setFilterViewVisibility] = useState(true);
  const [relateFieldData, setRelateFieldData] = useState({});
  const [data, setData] = useState([]);
  const [listViewLoading, setListViewLoading] = useState(false);
  const [listViewMeta, setListViewMeta] = useState({
    page: 0,
  });
  const history = useHistory()
  const [createRecordFields, setCreateRecordFields] = useState({assigned_user_name:{id:currentUserId,value:currentUserName}});
  const [searchFields, setSearchFields] = useState({});
  const [searchFieldsMeta, setSearchFieldsMeta] = useState({});
  //const [toastData, setToastData] = useState({ visible: false, message: "" });
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setErrors] = useState(errors);
  let iserror = errors[field.name] ? true : false;
  const currentSelectedModule = field.module ? field.module : module;
  const { CalendarListViewTabData } = useSelector((state) => state.calendar);
  
  const [selectedRecord, setSelectedRecords] = useState(view ==='calendar'?pathOr([], ['Calendar','data','user_ids'], CalendarListViewTabData):userData);
  const [selectedRecordIndex, setSelectedRecordIndexes] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRecordLength, setselectedRecordLength] = useState(selectAll ? "All " : selectedRecord.length)

  const { userPreference, config } = useSelector((state) => state.config);
  const site_url = pathOr("", ["config", "site_url"], config);

  const calendar_format = pathOr(config.default_date_format, ['attributes', 'global', 'calendar_format'], userPreference);
  const date_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_format'], userPreference);
  const time_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'time_reg_format'], userPreference);
  const date_reg_positions = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_positions'], userPreference);
  const [previewFile, setPreviewFile] = useState({ open: false, filename: "", filepath: "" });
  
  function truncate(str, n) {
    return str?.length > n ? str.substr(0, n - 1) + "..." : str;
  }

  const handleShowPreviewFile = (fname, url) => {
    let arr = fname.split(".");
    let ext = arr[arr.length - 1].toUpperCase();
    setPreviewFile({ open: true, filename: fname, filepath: url, filetype: ext });
  }
  const classes = useStyles();
  const theme = useTheme();
  const fetchRelateFieldData = useCallback(async () => {
    if (modalVisible) {
      try {
        setLoading(true);
        const res = await getRelateFieldData(currentSelectedModule, '20', '1', '-date_entered', '');
        if (res.ok) {
          setRelateFieldData(res.data);
        }
        setLoading(false);
      } catch (ex) {
        setLoading(false);
        toast("Something went wrong!");
      }
    }
  }, [currentSelectedModule, modalVisible]);

  useEffect(() => {
    fetchRelateFieldData();
  }, [fetchRelateFieldData]);


  const buildFilterQuery = () => {
    //console.log("searchFields ",searchFields);
    let filterQuery = "";
    let operator = 'eq';
    for (let key in searchFields) {
      // if(key==='first_name' || key==='last_name' || key==='name') 
      // {
      //   operator= 'lke';
      // }
      let operator = 'eq';
      let likeTypes = ['name', 'url'];
      if (likeTypes.includes(searchFieldsMeta[key].type)) {
        operator = 'lke';
      }
      let multiTypes = ['multienum'];
      //console.log("filterValuesMeta key",key);
      if (multiTypes.includes(searchFieldsMeta[key].type)) {
        operator = 'multi';

      }
      /// if (searchFields[key].length > 0 || searchFields[key] === true) {console.log("relate",searchFieldsMeta[key].type);
      if (searchFields[key]) {
        if (typeof searchFields[key] !== "object") {
          if (searchFieldsMeta[key].type === 'datetime' || searchFieldsMeta[key].type === 'datetimecombo') {

            // console.log("filterQueryfilterQuery  Object",searchFieldsMeta[key],searchFields,filterQuery);

            let dateSingleValue = ['next_7_days', 'last_7_days', 'last_month', 'this_month', 'next_month', 'last_30_days', 'next_30_days', 'this_year', 'last_year', 'next_year'];
            let dateDoubleValue = ['=', "not_equal", 'less_than', 'greater_than', 'less_than_equals', 'greater_than_equals'];
            let dateTripalValue = ['between'];

            if (dateSingleValue.some(item => searchFields[key] === item)) {
              filterQuery =
                filterQuery + `filter[range_${key}][${`operator`}]=${searchFields[key]}&`;
            } else if (dateDoubleValue.some(item => searchFields[key] === item)) {
              filterQuery =
                filterQuery + `filter[range_${key}][${operator}]=${searchFields['range_' + key]}&filter[${key}_range_choice][${`operator`}]=${searchFields[key]}&`;
            } else if (dateTripalValue.some(item => searchFields[key] === item)) {
              filterQuery =
                filterQuery + `filter[start_range_${key}][${operator}]=${searchFields['start_range_' + key]}&filter[end_range_${key}][${operator}]=${searchFields['end_range_' + key]}&filter[${key}_range_choice][${`operator`}]=${searchFields[key]}&`;
            }

          }
          else if (searchFieldsMeta[key].type === 'bool') {
            filterQuery =
              filterQuery + `filter[${key}][${operator}]=${searchFields[key] ? 1 : 0}&`;
          } else {
            let fval = encodeURIComponent(searchFields[key]);
            filterQuery =
              filterQuery + `filter[${key}][${operator}]=${fval}&`;

          }

        } else if (operator === 'multi') {
          if (searchFields[key].length > 0) {
            filterQuery =
              filterQuery + `filter[${key}][${operator}]=${searchFields[key] || []}&`;
          }

        } else if (searchFieldsMeta[key].type === 'relate') {
          filterQuery =
            filterQuery + `filter[${key}][]=${searchFields[key].id}&`;
        } else if (searchFieldsMeta[key].type === 'parent') {
          filterQuery =
            filterQuery + `filter[parent_type][${operator}]=${searchFields[key].parent_type}&filter[parent_name][${operator}]=${searchFields[key].parent_id}`;
        } else {
          filterQuery =
            filterQuery + `filter[${key}][${operator}]=${searchFields[key].id || []}&`;
        }
      }
    }
    return filterQuery;
  };

  const resetFields = async (fields, fieldsType) => {
    const fieldsCopy = clone(fields);
    for (let val in fieldsCopy) {
      fieldsCopy[val] = "";
    }
    setFilterViewVisibility(false);
    if (fieldsType === "setCreateRecordFields") {
      setCreateRecordFields(fieldsCopy);
      return;
    }
    setSearchFields(fieldsCopy);
    Object.keys(fieldsCopy).length && (await fetchRelateFieldData());
  };

  const stopParentSubmit = (event) => {
    console.log(event)
    event.stopPropagation();
  }

  const search = async () => {
    setLoading(true);
    try {
      const res = await relateFieldSearch(
        currentSelectedModule,
        buildFilterQuery(),
      );
      setListViewMeta({
        page: 0,
      });
      setLoading(false);
      if (res.ok) {
        
        // console.log("rrrrrrrrres",res)
        setRelateFieldData(res.data);
        return ;
      }
    } catch (ex) {
      toast("Something went wrong!");
    }
  };


  const saveRecord = async () => {
    setLoading(true);
    let createViewFields = pathOr(
      [],
      ["data", "templateMeta", "quickcreateview", 0, "attributes"],
      relateFieldData,
    );
    try {
      let validate = validateForm(createViewFields.flat(), createRecordFields, { calendar_format, date_reg_format, time_reg_format, date_reg_positions });
      
      setErrors(validate.errors);
      
      if (validate.formIsValid) {
        const data = {
          data: {
            type: currentSelectedModule,
            attributes: createRecordFields,
          },
        }
        let res = await relatePopupCreateSubmit(data);

        
        if (res.ok) {
          console.log("submit success",res);
          resetFields(createRecordFields, "setCreateRecordFields");
          setCreateViewVisibility(!createViewVisible);
          setListViewMeta({
            page: 0,
          });
        //  await fetchRelateFieldData();
          changePageOrSort(0, '-date_entered')
          toast("Record created successfully!");
          setLoading(false);
        }
        // dispatch(createRecord(data, '', module, history, "QuickCreate")).then(async (res) => {
         
          
        // })
        //   .catch((err) => {
        //     console.log(err);
        //   })
        // console.log(res);
        // // const dataRecieved = await res(record);
        // // console.log("Data Recieved",dataRecieved);
        // console.log("validate res",res);
        // if (res.ok) {
        //   resetFields(createRecordFields, "setCreateRecordFields");
        //   setCreateViewVisibility(!createViewVisible);
        //   await fetchRelateFieldData();
        //   // setToastData({
        //   //   visible: true,
        //   //   message: "Record created successfully!",
        //   // });
        //   toast("Record created successfully!");
        // }
      }
    } catch (ex) {
      setLoading(false);
      console.log("ex", ex);
      //setToastData({ visible: true, message: "Something went wrong!" });
      toast("Something went wrong!");
    }
  };

  const renderLoader = () => (
    <div className={classes.progressWrapper}>
      <CircularProgress />
    </div>
  );
  useEffect(() => {
    // console.log("dddddddata", data)
    let selectedIds = []
    data.map((content, key) => {
      if (selectedRecord.some(item => item === content.id)) {
        // console.log("dddddddatainnnnnnnnn", key, content.id)
        selectedIds.push(key);
        // selectedRecordIndex.push(key)

      }
      setSelectedRecordIndexes(selectedIds)
    })


  }, [data])

  const renderCreateView = () => {
    let createViewFields = pathOr(
      [],
      ["data", "templateMeta", "quickcreateview", 0, "attributes"],
      relateFieldData,
    );

    if (!createViewFields.length) return null;

    // if (!createViewVisible) {
    //   return (
    //     <div className={classes.perSectionWrapper}>
    //       <Button
    //         color="primary"
    //         variant="outlined"
    //         onClick={() => setCreateViewVisibility(!createViewVisible)}
    //       >
    //         Add Record
    //       </Button>
    //     </div>
    //   );
    // }

    return (
      <form  id='relate-create-form'  onSubmit={saveRecord}  noValidate autoComplete="off">
      <div className={classes.perSectionWrapper}>
        {loading ? renderLoader() : <>
          <Typography

            color="primary"
            className={classes.sectionTitle}
          >
            Create
          </Typography>
          <Grid container spacing={2}>
            {createViewFields.map((fieldArr) =>
              fieldArr.map((field) => (
                <Grid item xs={12} sm={6} md={4} ey={field.field_key}>
                  <FormInput
                    field={field}
                    key={field.field_key}
                    errors={fieldErrors}
                    value={createRecordFields[field.field_key]}
                    small={true}
                    onChange={(val) => {
                      if (field.type === "relate") {
                        setCreateRecordFields({
                          ...createRecordFields,
                          [field.name]: val.value,
                          [field.id_name]: val.id,
                        });
                        return;
                      }
                      setCreateRecordFields({
                        ...createRecordFields,
                        [field.field_key]: val,
                      });
                    }}
                  />
                </Grid>
              )),
            )}
            <div className={classes.buttonsWrapper}>
              <Button
                variant="contained"
                onClick={() => {
                  setCreateViewVisibility(!createViewVisible);
                  resetFields(createRecordFields, "setCreateRecordFields");
                }}
                color="primary"
                size="small"

                disableElevation
                className={classes.cstmBtn}
              >
                <Close /> Cancel
              </Button>

              <Button
                variant="contained"
                //onClick={saveRecord}
                color="primary"
                size="small"
                type="submit"
                disableElevation
                className={classes.cstmBtn}
                form='relate-create-form'
              >
                <Save /> Save
              </Button>
            </div>
          </Grid>
        </>
        }
      </div>
      </form>
    );
  };

  useEffect(() => {
    setData(pathOr(
      [],
      ["data", "templateMeta", "listview", "data"],
      relateFieldData,
    ))
  }, [relateFieldData])

  // let data = pathOr(
  //   [],
  //   ["data", "templateMeta", "listview", "data"],
  //   relateFieldData,
  // );

  let columns = pathOr(
    [],
    ["data", "templateMeta", "listview", "datalabels"],
    relateFieldData,
  ).map((it) => {
    if (it.name === "name" || (module === 'Documents' && it.name === "document_name")) {
      return {
        ...it,
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {

            const id = data[tableMeta["rowIndex"]].id;
            return (
              <Typography>

                <Link
                  // to={`/app/detailview/${module}/${id}`}
                  className={classes.link}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (!multiSelect) {
                      toggleModalVisibility(!modalVisible);
                      if (field.field_key === "aos_products") {
                        onChange({ id, value, 'rowData': data[tableMeta["rowIndex"]] });
                      }
                      else if (module === 'EmailTemplates') {
                        onChange({ id, value, 'email_template': data[tableMeta["rowIndex"]].attributes.body_html });
                      } 
                      else if (module === 'scrm_refPlan') {
                        onChange({ id, value });
                      }
                      else {
                        onChange({ id, value, 'email': (data[tableMeta["rowIndex"]].attributes && data[tableMeta["rowIndex"]].attributes.email1) ? data[tableMeta["rowIndex"]].attributes.email1 : "", 'rowData': data[tableMeta["rowIndex"]] });
                      }
                    }

                  }}
                  // component="button"
                  variant="body2"
                >
                  {value}
                </Link>
              </Typography>
            );
          },
        },
      };
    }
    if (it.type === "file") {
      return {
        ...it,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let furl = `${site_url}/index.php?entryPoint=customDownload&id=${data[tableMeta["rowIndex"]].id}&type=${module}`;
            return (
              value ?
                <Typography>
                  <VisibilityIcon fontSize='small' style={{ margin: "-1vh", marginLeft: "1vh", marginRight: "1vw", cursor: "pointer" }} onClick={() => handleShowPreviewFile(value, furl)} />
                  <Tooltip title={value}>
                    <Link style={{ cursor: "pointer" }} to={`#`} className={classes.link} onClick={() => { saveAs(furl, data[tableMeta["rowIndex"]].filename); toast("Downloading in progress!"); }}
                      variant="body2"
                    >
                      {truncate(value, 20) || truncate(data[tableMeta["rowIndex"]].document_name, 20) || ""}
                    </Link>
                  </Tooltip>
                </Typography> : ""
            );
          },
        },
      };
    }
    return it;
  });


  const handleSelectChange = (currentRowsSelected = null, allRowsSelected = null, rowsSelected = null) => {
    setSelectAll(false);
    // const selectedRecordsId = selectedRecordsId;
    // const selectedRecordsIndex = [];
    // console.log("rows")
    // console.log(currentRowsSelected)
    // console.log(allRowsSelected)
    // console.log(rowsSelected)
    // console.log(selectedRecord)
    // console.log(selectedRecordIndex)
    if (currentRowsSelected.length === 0) {
      data.forEach((feed, i) => {
        var indexselectedRecord = selectedRecord.indexOf(feed.id)
        var indexselectedIndex = selectedRecordIndex.indexOf(i)
        if (indexselectedRecord !== -1) {
          selectedRecord.splice(indexselectedRecord, 1);
        }
        if (indexselectedIndex !== -1) {
          selectedRecordIndex.splice(indexselectedIndex, 1);
        }
      })
    } else {
      currentRowsSelected.forEach((feed, i) => {
        if (selectedRecord.some(item => data[feed.index].id === item)) {
          var indexselectedRecord = selectedRecord.indexOf(data[feed.index].id)
          var indexselectedIndex = selectedRecordIndex.indexOf(feed.index)
          if (indexselectedRecord !== -1) {
            selectedRecord.splice(indexselectedRecord, 1);
          }
          if (indexselectedIndex !== -1) {
            selectedRecordIndex.splice(indexselectedIndex, 1);
          }
        } else {
          let dataArr = data[feed.index].id;
          if(component==='reminder')
          {
            dataArr = {id:'',module_id:data[feed.index].id,module:module,value:pathOr("",["attributes","name"],data[feed.index]),name:pathOr("",["attributes","name"],data[feed.index]),email1:pathOr("",["attributes","email1"],data[feed.index])};
          }

          // console.log("data[feed.index]",data[feed.index]);
          selectedRecord.push(dataArr);
          selectedRecordIndex.push(feed.index)


        }

      });
    }
    // console.log("rrrrrrrrrrrrrrrrrrow")
    // console.log(selectedRecord)
    // console.log(selectedRecordIndex)
    setselectedRecordLength(selectAll ? "All " : selectedRecord.length)
    // setSelectedRecords(selectedRecordsId)
    // setSelectedRecordIndexes(selectedRecordsIndex)
  }
  const multiSelectRecords = (data) => {
    toggleModalVisibility(!modalVisible);
    onChange(data)
  }
  const changePageOrSort = async (page, sort) => {
    try {
      setLoading(true);
      setListViewMeta({ page });
      const res = await getRelateFieldData(
        currentSelectedModule,
        20,
        page + 1,
        sort,
        buildFilterQuery(),
        reportsTo
      );


      setRelateFieldData(res.data);
      setSelectAll(false)
      setselectedRecordLength(selectAll ? "All " : selectedRecord.length)
      // setSelectedRecords([])
      // setSelectedRecordIndexes([])

      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  // console.log("relateFieldData",relateFieldData)

  const renderListView = () => {
    // console.log("selectedRecordIndexselectedRecordIndex",selectedRecordIndex)
    return (
      <MuiThemeProvider theme={getMuiTheme(theme)}>

        {loading ? renderLoader() : ''}
        <Box display={!loading ? 'block' : 'none'}>
          <MUIDataTable
            // title={
            //   <Typography variant="h6">
            //     {currentSelectedModule}
            //     {listViewLoading && <CircularProgress size={24} />}
            //   </Typography>
            // }
            data={data.map((it) => it.attributes)}
            columns={columns}
            options={{
              filter: false,
              download: false,
              print: false,
              viewColumns: false,
              selectableRows: multiSelect ? true : false,

              onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => handleSelectChange(currentRowsSelected, allRowsSelected, rowsSelected),
              rowsSelected: (selectedRecordIndex),
              page: listViewMeta["page"],
              count: pathOr(0, ["meta", "total-records"], relateFieldData),
              search: false,
              rowsPerPage: 20,
              fixedHeader: true,
              serverSide: true,
              //tableBodyHeight: "500px",
              customToolbar: () => {
              return view ==='calendar'?<Button className={classes.btn} style={{float:'left'}} color="primary" variant="outlined" onClick={() => multiSelectRecords(['clear'])}>Clear</Button>:null;
              },
              customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
                return <Button className={classes.btn} color="primary" variant="outlined" onClick={() => multiSelectRecords(selectedRecord)}>Select</Button>;
              },
              rowsPerPageOptions: [20],
              onTableChange: (action, tableState) => {
                // console.log("onTableChange tableState",action,tableState);
                switch (action) {
                  case "changePage":
                    if (tableState.sortOrder.hasOwnProperty("name")) {
                      let directionToSort =
                        tableState.sortOrder.direction === "desc"
                          ? `-${tableState.sortOrder.name}`
                          : tableState.sortOrder.name;
                      changePageOrSort(tableState.page, directionToSort);
                      // setListViewMeta({
                      //   ...listViewMeta,
                      //   page: tableState.page + 1,
                      // });
                      break;
                    }
                    changePageOrSort(tableState.page);
                    break;
                  case "sort":
                    if (tableState.sortOrder.direction === "desc") {
                      changePageOrSort(
                        tableState.page,
                        `-${tableState.sortOrder.name}`,
                      );
                      break;
                    }
                    changePageOrSort(
                      tableState.page,
                      tableState.sortOrder.name,
                    );

                    break;
                  default:
                  // console.log("action not handled.");
                }
              },
              textLabels: {
                body: {
                  noMatch: loading ? "Please wait while we load your data." : <div style={{ padding: "10px 5px 10px 5px" }}><Alert variant="outlined" severity="warning">
                    No results found... Perhaps change your search criteria and try again?
                  </Alert></div>,
                },
              }
            }}
          />
        </Box>

        {(previewFile.open) ? <FileViewerComp previewFile={previewFile} setPreviewFile={setPreviewFile} /> : ""}
      </MuiThemeProvider>
    );
  };

  const renderViews = () => {
    let createViewFields = pathOr(
      null,
      ["data", "templateMeta", "quickcreateview", 0],
      relateFieldData,
    );
    let searchViewFields = pathOr(
      null,
      ["data", "templateMeta", "searchview", 0],
      relateFieldData,
    );

    return (
      <div className={classes.sectionsWrappers}>
        <Box style={{ marginBottom: 10 }}>
          {searchViewFields && view !== 'calendar' && <Button size="small" className={classes.btn} color="primary" variant="outlined" onClick={() => { setCreateViewVisibility(false); setFilterViewVisibility(!filterViewVisible) }}><SearchIcon /> Search</Button>}
          {createViewFields && (currentSelectedModule !== 'AOR_Reports') && <Button size="small" className={classes.btn} color="primary" variant="outlined" onClick={() => { setFilterViewVisibility(false); setCreateViewVisibility(!createViewVisible) }}><Add />  Create</Button>}
        </Box>
        <Box>
          {filterViewVisible && view !== 'calendar' ?
            <SearchView
              relateFieldData={relateFieldData.data}
              stopParentSubmit={stopParentSubmit}
              resetFields={resetFields}
              search={search}
              searchFields={searchFields}
              setSearchFields={setSearchFields}
              moduleLabel={currentSelectedModule}
              searchFieldsMeta={searchFieldsMeta}
              setSearchFieldsMeta={setSearchFieldsMeta}
            /> : ""}
          {createViewVisible ? renderCreateView() : ""}
          {renderListView()}
        </Box>
      </div>
    );
  };

  const renderBody = () => {
    return (
      <Paper square className={classes.paper}>
        <Scrollbars autoHide={true}>
          <div className={classes.titleHeadWrapper}>
            <Typography variant="h6" style={{ fontWeight: "500", color: theme.palette.text.primary }}>
              {pathOr(currentSelectedModule, ['moduleList', currentSelectedModule], app_list_strings)}
            </Typography>
            <Close
              onClick={() => toggleModalVisibility(!modalVisible)}
              className={classes.closeIcon}
            />
          </div>
          {renderViews()}
          {/* <Toast
            showToast={toastData.visible}
            msg={toastData.message}
            onClose={() => setToastData({ visible: false, toastMessage: "" })}
          /> */}
        </Scrollbars>
      </Paper>
    );
  };

  return (
    <>
      <Tooltip
        title={field.comment ? field.comment : ''}
        disableHoverListener={field.comment ? false : true}
        placement="top-start"
        disableFocusListener={field.comment ? false : true}
        disableTouchListener={field.comment ? false : true}
      >
        {!isIconBtn ?
          (<>
          <TextField
            id={field.name}
            name={field.name}
            error={iserror}
            required={field.required === 'true' ? true : false}

            variant={variant}
            size={small ? "small" : "medium"}
            label={field.label}
            onChange={(e) => onChange(e.target.value)}
            value={value.value}
            disabled={true}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start" className={classes.adornment}>
                  {value.value && <Close onClick={() => onChange("")} />}
                  <SearchIcon onClick={() => toggleModalVisibility(!modalVisible)} />
                </InputAdornment>
              ),
            }}
            helperText={errors[field.name] ? errors[field.name] : null}
          /></>) :
          (
          <Tooltip title={tooltipTitle ? tooltipTitle : ''}  aria-label={tooltipTitle}>
            {isSelectBtn ? <Button color={color} variant={variant} size="small" disabled={disabled} onClick={() => toggleModalVisibility(!modalVisible)}>{btnIcon} Select{view==='calendar'?" Users":null}</Button> :
              <IconButton onClick={() => toggleModalVisibility(!modalVisible)}>
                {btnIcon}
              </IconButton>}
          </Tooltip>
          )
        }
      </Tooltip>
      <Modal
        open={modalVisible}
        onClose={() => toggleModalVisibility(!modalVisible)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {renderBody()}
      </Modal>
    </>
  );
};

export default Relate;